module.exports = __webpack_public_path__ + "static/media/ehealth_pro_acc_p4_2.95943407.png";